export default __webpack_public_path__ + "static/media/vid-holder-sinverse-licenses.999da870.png";